// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__ATpio","title":"Footer_title__LGKHD"};